import { useState } from "react";
import StudentFilters from "../../components/StudentFilters"
import { PlusIcon } from "@heroicons/react/20/solid";

export default function StudentManagement({ permission }) {
    const [students, setStudents] = useState([
        {
            id: "USR001",
            name: "Michel Shen",
            avatar: "https://i.pravatar.cc/40?img=1",
            application: "Math Genius",
            grade: "Grade 6 – A",
            status: "Not Enrolled",
        },
        {
            id: "USR001",
            name: "Michel Shen",
            avatar: "https://i.pravatar.cc/40?img=1",
            application: "Science Lab",
            grade: "Grade 6 – A",
            status: "Enrolled",
        },
        {
            id: "USR001",
            name: "Michel Shen",
            avatar: "https://i.pravatar.cc/40?img=1",
            application: "Math Genius",
            grade: "Grade 6 – A",
            status: "Not Enrolled",
        },
        {
            id: "USR001",
            name: "Michel Shen",
            avatar: "https://i.pravatar.cc/40?img=1",
            application: "Science Lab",
            grade: "Grade 6 – A",
            status: "Enrolled",
        },
    ]);

    // ✅ Fix: keep this outside return
    const toggleStatus = (index) => {
        const updated = [...students];
        updated[index].status =
            updated[index].status === "Enrolled" ? "Not Enrolled" : "Enrolled";
        setStudents(updated);
    };

    return (
        <>

            <div className="flex justify-between my-4">
                <div>
                    <StudentFilters />
                </div>
                <div>
                    {permission?.enrollNewStudent === true &&
                        <button className="bg-primary-600 px-4 py-3 rounded-lg text-white text-sm font-medium hover:bg-primary-200 flex justify-between cursor-not-allowed">
                            <PlusIcon className="w-5 h-5 text-white" />   Enroll Student
                        </button>
                    }
                </div>
            </div>
            <div className="card">
                <div className="card-body">


                    <div className=" mt-8">
                        <div className="bg-white shadow-md rounded-xl overflow-hidden">
                            <table className="w-full text-sm text-left">
                                <thead className="bg-gray-50 border-b">
                                    <tr>
                                        <th className="p-3">
                                            <input type="checkbox" />
                                        </th>
                                        <th className="p-3">STUDENT NAME</th>
                                        <th className="p-3">APPLICATION</th>
                                        <th className="p-3">GRADE</th>
                                        <th className="p-3">STATUS</th>
                                        {permission?.enrollandDropStudent === true && <th className="p-3">ACTION</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {students.map((student, index) => (
                                        <tr key={index} className="border-b hover:bg-gray-50 shadow-sm hover:shadow-md transition">
                                            <td className="p-3">
                                                <input type="checkbox" />
                                            </td>
                                            <td className="p-3 flex items-center gap-2">
                                                <img
                                                    src={student.avatar}
                                                    alt={student.name}
                                                    className="w-8 h-8 rounded-full"
                                                />
                                                <div>
                                                    <p className="font-medium">{student.name}</p>
                                                    <p className="text-xs text-gray-500">ID: {student.id}</p>
                                                </div>
                                            </td>
                                            <td className="p-3">
                                                <span
                                                    className={`px-3 py-1 rounded-md text-xs font-medium ${student.application === "Math Genius"
                                                        ? "bg-yellow-100 text-yellow-700"
                                                        : "bg-indigo-100 text-indigo-700"
                                                        }`}
                                                >
                                                    {student.application}
                                                </span>
                                            </td>
                                            <td className="p-3">{student.grade}</td>
                                            <td className="p-3 flex items-center gap-2">
                                                <span
                                                    className={`w-2 h-2 rounded-full ${student.status === "Enrolled"
                                                        ? "bg-green-500"
                                                        : "bg-gray-400"
                                                        }`}
                                                ></span>
                                                {student.status}
                                            </td>
                                            {permission?.enrollandDropStudent === true &&
                                                <td className="p-3">
                                                    <button
                                                        onClick={() => toggleStatus(index)}
                                                        className={`px-4 py-1 rounded-md text-white text-sm ${student.status === "Enrolled"
                                                            ? "bg-gray-600 hover:bg-gray-700"
                                                            : "bg-green-600 hover:bg-green-700"
                                                            }`}
                                                    >
                                                        {student.status === "Enrolled" ? "Drop" : "Enroll"}
                                                    </button>
                                                </td>
                                            }
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {/* Footer */}
                            <div className="flex justify-between items-center p-4 text-sm text-gray-600">
                                <span>1 - 10 of 13 Pages</span>
                                <div className="flex gap-2">
                                    <button className="px-2 py-1 border rounded-md">&lt;</button>
                                    <button className="px-2 py-1 border rounded-md">&gt;</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}
